import React, { useEffect } from 'react';
import FormBuilder from "../components/FormikBuilder";
import InputDateBuilder from '../components/FormikBuilder/InputDateBuilder';
import ButtonBuilder from '../components/FormikBuilder/ButtonBuilder';
import InputAutoCompleteBuilder from '../components/FormikBuilder/InputAutoCompleteBuilder';
import filterPendency from '../contexts/filterPendency';
import http from '../utils/api';
import { getColaboradorAcessos } from '../utils/storage';


function FilterPendency(props) {
    const {data, dateTime, ...other} = props;

    const renderColaboradorFilter = getColaboradorAcessos().find(ca => ca.codigoNivelOperacao === 'SH' || ca.codigoNivelOperacao === 'RC' )!== undefined;
    return (
        <FormBuilder key={'filterSaldoHoras'} data={data} initialState={filterPendency} schema={() => ({
            props: {
                PaperProps: {
                    style: {
                        minHeight: 260
                    },
                },
            },
            onSubmit: console.log,
        })} {...other}>
            {
                (form, props) => {

                    useEffect(() => {
                        if (form.isSubmitting){
                            form.setSubmitting(false);
                            if (!form.values.codColaborador){
                                const inicio = form.values.inicio;
                                const fim = form.values.fim;
                                form.setValues({
                                    inicio,
                                    fim,
                                    codColaborador: data.codColaborador, 
                                    nomeColaborador: data.nomeColaborador
                                }
                                ?? {})
                            }
                        }
                    });

                    const onChangeAutoComplete = () => (ev, value = {}) => {
                        const inicio = form.values.inicio;
                        const fim = form.values.fim;
                       
                        form.setValues({
                                inicio,
                                fim,
                                ...value,
                            }
                            ?? {})
                    };

                    return (<>
                        { renderColaboradorFilter ? (
                            <InputAutoCompleteBuilder form={form} formProps={props} fieldSchema={{
                                label: 'Colaborador',
                                field: 'codigoColaborador',
                                sizes: {
                                    sm: 12,
                                    lg: 5,
                                },
                                listen: 'codigoColaborador',
                                getOptions: (async (setOptions) => {
                                    const response = await http.get('colaborador/liderados', {
                                        params: {
                                            
                                        }
                                    });
                                    let resultsArray = (response?.data ?? []).map(option => {
                                        return {
                                            codColaborador: option.codigoColaborador, 
                                            nomeColaborador: option.nome
                                        }
                                    });
                                    setOptions(resultsArray);
                                }),
                                onChange: onChangeAutoComplete(),
                                getOptionLabel: option => (option?.['nomeColaborador']) || '',
                                type: 'autocomplete',
                            }}/>
                        ) : (
                            <></>
                        )}
                        <InputDateBuilder form={form} formProps={props} fieldSchema={{
                            label: 'Início',
                            field: 'inicio',
                            sizes: {
                                sm: 12,
                                lg: 3,
                            },
                            format: 'MM/YY',
                            type: 'date',
                            isRequired: true,
                            openTo: 'month',
                            views: ['month', 'year'],
                        }}/>
                        <InputDateBuilder form={form} formProps={props} fieldSchema={{
                            label: 'Fim',
                            field: 'fim',
                            sizes: {
                                sm: 12,
                                lg: 3,
                            },
                            format: 'MM/YY',
                            type: 'date',
                            isRequired: true,
                            openTo: 'month',
                            views: ['month', 'year'],
                        }}/>
                        <ButtonBuilder form={form} formProps={props} fieldSchema={{
                            label: 'Filtrar',
                            type: 'button',
                            typeButton: 'submit',
                            sizes: {
                                sm: 12,
                                lg: 3,
                            },
                        }}/>
                    </>)
                }
            }
        </FormBuilder>);
}

export default FilterPendency;
